<ol>
  @for (bookmark of bookmarks(); track bookmark.id) {
    <li>
      <button (click)="navigateToBookmark(bookmark)">
        <span class="label">{{ bookmark.chapterTitle }}</span>
        <span class="progress">{{ bookmark.progress | number: '1.0-0' }}%</span>

        <odl-button
          (click)="$event.stopImmediatePropagation()"
          [id]="triggerId(bookmark.id)"
          [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
        >
          <odl-icon name="more_vert" slot="only-icon"></odl-icon>
        </odl-button>
        <odl-tooltip [attr.for]="'#' + triggerId(bookmark.id)">
          {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
        </odl-tooltip>

        <odl-menu
          (click)="$event.stopImmediatePropagation()"
          [attr.for]="'#' + triggerId(bookmark.id)"
          placement="bottom-end"
        >
          <odl-menu-item (odl-select)="navigateToBookmark(bookmark)">
            <odl-icon name="arrow_forward" slot="icon"></odl-icon>
            <span>{{ 'NAVIGATION.BOOKMARKS.GO_TO' | translate }}</span>
          </odl-menu-item>

          <odl-menu-item (odl-select)="$event.stopImmediatePropagation(); deleteBookmark(bookmark)">
            <odl-icon name="delete" slot="icon"></odl-icon>
            <span>{{ 'NAVIGATION.BOOKMARKS.DELETE' | translate }}</span>
          </odl-menu-item>
        </odl-menu>
      </button>
    </li>
  }
</ol>
